import { range } from 'underscore';
import SkeletonPulse from '~/components/common/v2/skeleton-loader';
import {
  StyledSkeletonLarge,
  StyledSkeletonShort,
  StyledDivider,
  SkeletonCardWrapper,
  SkeletonCardBody,
} from './AdvancedSearchResultsSkeleton.styles';

type AdvancedSearchResultsSkeletonProps = {
  numOfResults?: number;
};

const ResultSkeleton = () => (
  <SkeletonCardBody>
    <SkeletonPulse height={24} baseColorValue={100} wrapper={StyledSkeletonLarge} />
    <SkeletonPulse height={16} baseColorValue={100} wrapper={StyledSkeletonShort(3)} />
    <SkeletonPulse height={16} baseColorValue={100} wrapper={StyledDivider(4)} />
  </SkeletonCardBody>
);

export const AdvancedSearchResultsSkeleton = ({ numOfResults = 6 }: AdvancedSearchResultsSkeletonProps) => (
  <SkeletonCardWrapper data-testid="advanced-search-results-skeleton">
    {range(numOfResults).map((n) => (
      <ResultSkeleton key={n} />
    ))}
  </SkeletonCardWrapper>
);
